import { de } from './de';
import { en } from './en';
import { es } from './es';
import { ILang } from './type';

export const tagPosition = [
    {
        pcTop: '39%',
        pcLeft: '22%',
        mobileTop: '39%',
        mobileLeft: '16%'
    },
    {
        pcTop: '61%',
        pcLeft: '18%',
        mobileTop: '58%',
        mobileLeft: '8%'
    },
    {
        pcTop: ' 76%',
        pcLeft: '36%',
        mobileTop: '71%',
        mobileLeft: '38%'
    },
    {
        pcTop: '31%',
        pcLeft: '52%',
        mobileTop: '33%',
        mobileLeft: '63%'
    },
    {
        pcTop: '54%',
        pcLeft: '50%',
        mobileTop: '52%',
        mobileLeft: '53%'
    },
    {
        pcTop: ' 80%',
        pcLeft: '54%',
        mobileTop: '74%',
        mobileLeft: '62%'
    },
    {
        pcTop: ' 51%',
        pcLeft: '76%',
        mobileTop: '49%',
        mobileLeft: '91%'
    }
];

export const langList: Record<string, ILang> = {
    de,
    en,
    es
};
